/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  padding: 50px;
  padding-top: 10px;

  h1,
  h2 {
    color: #fff;
    margin-top: 10px;
  }
  p {
    color: #fff;
  }

  div.profile {
    padding: 30px;
    font-size: 16px;
    line-height: 30px;
  }

  div.update {
    div {
      width: 40%;
      padding: 10px;
      height: 10%;

      p {
        font-size: 16px;
        margin-top: 10px;
      }

      button {
        margin: 0px 0px 0px 8%;
        height: 30px;
        width: 90px;
        background: #36ded6;
        font-weight: bold;
        color: #090f35;
        border: 0;
        border-radius: 5px;
        font-size: 14px;
        transition: background 0.2s;

        &:hover {
          background: ${darken(0.08, '#36ded6')};
        }
      }
    }
  }

  div.conquer {
    display: grid;
    grid-template-columns: 400px 400px 400px;
    grid-row-gap: 10px;
    grid-column-gap: 40px;
    div.card {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      width: 400px;
      height: 110px;
      border: 1px solid #fff;
      border-radius: 5px;
      margin: 10px;

      img {
        width: 150px;
        height: 100px;
        margin-right: 10px;
      }

      p {
        margin-top: 5px;
      }
    }
  }

  div.jobs {
    display: grid;
    grid-template-columns: 400px 400px 400px;
    grid-row-gap: 10px;
    grid-column-gap: 40px;
    div.card {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      width: 400px;
      height: 110px;
      border: 1px solid #fff;
      border-radius: 5px;
      margin: 10px;

      img {
        width: 150;
        height: 100px;
        margin-right: 10px;
      }

      p {
        margin-top: 5px;
      }
    }
  }

  div.challenges {
    padding-bottom: 30px;
    display: grid;
    grid-template-columns: 400px 400px 400px;
    grid-row-gap: 10px;
    grid-column-gap: 40px;

    div.card {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 400px;
      padding: 10px;
      border: 1px solid #fff;
      border-radius: 5px;
      margin: 10px;
      margin-bottom: 0;

      img {
        width: 150;
        height: 100px;
        margin-right: 10px;
      }

      p {
        margin-top: 5px;
      }
    }
  }
`;
